// English translations for project name / scope-of-work / location.
// Keyed by slug. Proper nouns (company names, currency, year) stay as-is.
export const projectsEn = {
  "cezayir-stadyum-kompleksi": {
    name: "Algeria 50,000-Seat Stadium Complex",
    is: "Stade Hocine Aït Ahmed — 50,000 seats / Tizi Ouzou",
    location: "Tizi Ouzou, Algeria",
  },
  "kocaeli-kultur-sanat-merkezi": {
    name: "Kocaeli Culture & Arts Center",
    is: "Kocaeli Culture Center LV–MV–Weak Current electrical works",
    location: "Kocaeli",
  },
  "cezayir-hastane-otel-otopark": {
    name: "Algeria Hospital, Hotel & Car Park Complex",
    is: "Electrical works for the Algeria Hospital, Hotel & Car Park Complex",
    location: "Algeria",
  },
  "bilisim-vadisi-2-etap": {
    name: "Informatics Valley Incubation Buildings & Congress Center — Phase 2",
    is: "LV–MV electrical works — Informatics Valley Incubation Buildings & Congress Center, Phase 2",
    location: "Kocaeli",
  },
  "acibadem-hastanesi": {
    name: "Acıbadem Hospital",
    is: "General electrical works",
    location: "Kocaeli",
  },
  "sakarya-egitim-arastirma-hastanesi": {
    name: "Sakarya 400-Bed Training & Research Hospital",
    is: "General electrical works — Sakarya 400-Bed State Hospital",
    location: "Sakarya",
  },
  "rize-egitim-arastirma-hastanesi": {
    name: "Rize 250-Bed Training & Research Hospital",
    is: "General electrical works — Rize 250-Bed State Hospital",
    location: "Rize",
  },
  "golcuk-devlet-hastanesi": {
    name: "Gölcük State Hospital",
    is: "General electrical works — 400 kVA, 70-bed hospital",
    location: "Kocaeli",
  },
  "medicalpark-hastanesi": {
    name: "Medicalpark Hospital",
    is: "General electrical works — Sembol Mall & Medical Park Hospital",
    location: "Kocaeli",
  },
  "turkiye-hastanesi": {
    name: "Türkiye Hospital",
    is: "LV–MV–Weak Current electrical works — Türkiye Hospital Maternity & Pediatrics Unit",
    location: "Istanbul",
  },
  "akyazi-devlet-hastanesi": {
    name: "Akyazı 100-Bed State Hospital",
    is: "General electrical works",
    location: "Sakarya",
  },
  "dedeman-otel": {
    name: "Dedeman Hotel",
    is: "General electrical works — Nuh Mall, Dedeman Hotel & Mall",
    location: "Kocaeli",
  },
  "bayramoglu-resort": {
    name: "Bayramoğlu Resort",
    is: "General electrical works",
    location: "Kocaeli",
  },
  "coca-cola": {
    name: "Coca-Cola C.O",
    is: "General electrical works",
    location: "Erbil/Iraq — Kabul/Afghanistan",
  },
  "tofas": {
    name: "Tofaş Türk Automobile Factory Inc.",
    is: "General electrical works",
    location: "Bursa",
  },
  "mercedes-benz": {
    name: "Mercedes-Benz Inc.",
    is: "General electrical works",
    location: "Aksaray",
  },
  "frito-lay": {
    name: "Frito-Lay Food Industry",
    is: "General electrical works — warehouse, office and cafeteria",
    location: "Kocaeli",
  },
  "izfas-fuar-merkezi": {
    name: "İzfaş International Fair Center",
    is: "3×1600 kVA transformer and 30,000 m² electrical works",
    location: "Izmir",
  },
  "msb-helikopter-ussu": {
    name: "Ministry of Defense Helicopter Base",
    is: "General electrical works",
    location: "Çanakkale",
  },
  "sasa-inegol-tesisi": {
    name: "Sasa İnegöl Facility",
    is: "800 m² general electrical works",
    location: "Bursa",
  },
  "enerjisa": {
    name: "Enerjisa Inc.",
    is: "Electrical works — STG security, sand building, perimeter lighting and HQ building",
    location: "Adana / Kocaeli / Çanakkale",
  },
  "yalova-elyaf-fabrikasi": {
    name: "Yalova Fiber Factory",
    is: "Spinning Mill 3 / Industrial Water Treatment Plant",
    location: "Yalova",
  },
  "ingersoll-rand": {
    name: "Ingersoll Rand",
    is: "6 MVA MV facility — factory lighting project",
    location: "Kocaeli",
  },
  "tesco-kipa-avm": {
    name: "Tesco Kipa Shopping Center",
    is: "General electrical works — supermarket and stores",
    location: "Kırıkkale / Edirne",
  },
  "carrefoursa-avm": {
    name: "Carrefoursa Shopping Center",
    is: "34.5 kV power transmission line",
    location: "Kocaeli",
  },
  "tansas-avm": {
    name: "Tansaş Shopping Center",
    is: "General electrical works — supermarket and stores",
    location: "Izmir",
  },
  "dolphin-avm": {
    name: "Dolphin Shopping Center",
    is: "2×1600 kVA transformer and 40,000 m² enclosed shopping center",
    location: "Kocaeli",
  },
  "arasta-park-avm": {
    name: "Arasta Park Shopping Center",
    is: "Arasta Park Mall electrical workmanship service",
    location: "Kocaeli",
  },
  "symbol-medicalpark": {
    name: "Symbol - Medicalpark",
    is: "General electrical works — Sembol Mall & Medical Park Hospital",
    location: "Kocaeli",
  },
  "istanbul-unv-ulastirma-myo": {
    name: "Istanbul Univ. Transportation Vocational School",
    is: "General electrical works",
    location: "Istanbul",
  },
  "ilka-plastik": {
    name: "İlka Plastik",
    is: "General electrical works — campus construction",
    location: "Kocaeli",
  },
  "bilisim-vadisi-1-etap": {
    name: "Informatics Valley Incubation Buildings & Congress Center — Phase 1",
    is: "LV–MV electrical works — Informatics Valley Incubation Buildings & Congress Center, Phase 1",
    location: "Kocaeli",
  },
  "f16-simulator-binalari": {
    name: "F-16 Simulator Buildings",
    is: "General electrical works (Balıkesir, Bandırma, Ankara, Merzifon, Diyarbakır)",
    location: "Nationwide",
  },
  "havelsan-pendik": {
    name: "Havelsan Pendik Service Building",
    is: "General electrical works",
    location: "Istanbul",
  },
  "teknosa-lojistik": {
    name: "Teknosa Logistics",
    is: "General electrical works",
    location: "Kocaeli",
  },
  "und-as": {
    name: "Und Inc.",
    is: "General electrical works — Und Gürbulak Border Gate",
    location: "Gürbulak",
  },
  "ipekyol-tekstil": {
    name: "İpekyol Textile Inc.",
    is: "Electrical works — İpekyol Textile administration building",
    location: "Istanbul",
  },
  "kocaeli-sanayi-odasi": {
    name: "Kocaeli Chamber of Industry",
    is: "General electrical works — social facility and service building",
    location: "Kocaeli",
  },
  "uskudar-belediyesi": {
    name: "Üsküdar Municipality Annex Service Building",
    is: "LV–MV electrical works — Üsküdar Municipality Annex Service Building",
    location: "Istanbul",
  },
  "adana-stadyumu": {
    name: "Adana 33,000-Seat Stadium",
    is: "Electrical works — Adana 33,000-seat stadium",
    location: "Adana",
  },
  "atasehir-konutlari": {
    name: "Ataşehir Residences",
    is: "General electrical works",
    location: "Istanbul",
  },
  "bahcekent-konaklari": {
    name: "Bahçekent Mansions",
    is: "General electrical works",
    location: "Kocaeli",
  },
};
